import { computed, unref } from 'vue';

import { propsFactory, paramCase } from '@components/utils';

import type { MaybeRef } from '@components/utils';
import type { ComputedRef, PropType } from 'vue';

export type TAppearance = typeof allowedAppearance[number];
export interface IAppearanceProps {
  appearance: TAppearance;
}
export interface IUseAppearance {
  appearanceClasses: ComputedRef<string>;
}

export const allowedAppearance = ['primary', 'secondary', 'tertiary', 'inverse', 'transparent'] as const;
export const makeAppearanceProps = propsFactory(
  {
    /**
     * Внешний вид
     */
    appearance: {
      type: String as PropType<TAppearance>,
      default: 'primary',
      available: allowedAppearance,
      validator: (value: TAppearance) => allowedAppearance.includes(value)
    }
  },
  'appearance'
);

export function useAppearance(props: MaybeRef<IAppearanceProps>, name: string): IUseAppearance {
  const appearanceClasses = computed(() => {
    const { appearance } = unref(props);
    return `${paramCase(name)}__appearance--${appearance}`;
  });

  return { appearanceClasses };
}
